<a
  class="btn btn-action btn-small back-navigation"
  [routerLink]="{ cxRoute: 'rebateClaims' } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('rebateClaims')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.rebateClaims' | cxTranslate }}
</a>

@if (rebateClaim) {
  <div class="container">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'rebateClaims.rebateClaimHistory.claimId' | cxTranslate }}</b>
          @if (rebateClaim?.rebateClaimCode) {
            <span>{{ rebateClaim?.rebateClaimCode }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'rebateClaims.rebateClaimHistory.value' | cxTranslate }}</b>
          @if (rebateClaim?.formattedClaimAmount) {
            <span>{{ rebateClaim?.formattedClaimAmount }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'rebateClaims.rebateClaimHistory.claimDate' | cxTranslate }}</b>
          @if (rebateClaim?.claimDate) {
            <span>{{ rebateClaim?.claimDate | cxDate: 'longDate' }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'rebateClaims.rebateClaimHistory.gst' | cxTranslate }}</b>
          @if (rebateClaim?.formattedGst) {
            <span>{{ rebateClaim?.formattedGst }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'shared.status' | cxTranslate }}</b>
          @if (rebateClaim?.status) {
            <span>{{ rebateClaim?.status }}</span>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'rebateClaims.claimMonth' | cxTranslate }}</b>
          @if (rebateClaim?.calendarMonth) {
            <span>{{ rebateClaim?.calendarMonth | titlecase }}</span>
          }
        </div>
        <div class="col-12 agreement-detail-actions">
          <button class="btn btn-primary btn-small" (click)="downloadCSV()" [disabled]="!entries?.items?.length">
            <i class="fa fa-download"></i>
            {{ 'rebateClaims.downloadDetailsCsv' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (entries) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="product.code"
    [rows]="entries.items"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showInitialLoader) {
    <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
  }
}


@if (showInitialLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
